import React from "react";
import { Radio } from "antd";
import { savedInRadioValues } from "../../../publicDictionaryValues";
import BaseComponent from "../../../../base/common/BaseComponent";
import styles from "./index.module.scss";
import redTipIcon from "../../../../assets/image/redTipIcon.png";
import NormalToolTip from "../../../../base/basicComponents/toolTip";

export default class BaseProcedureSavedIn extends BaseComponent {
  savedInMessage = () => {
    return (
      <div className={styles.messageWrapper}>
        <div className={styles.title}>
          Attention! If the "Procedure Saved In" value is changed to "Client Server Only", all
          procedure files will be deleted upon submission. Please double check whether you want to
          make the change.
        </div>
      </div>
    );
  };

  savedInMessageIcon = () => {
    if (this.props.isShowSavedInIcon)
      return (
        <NormalToolTip
          element={
            <div className={styles.disabledTipIcon}>
              <img src={redTipIcon} alt="Reject" />
            </div>
          }
          title={this.savedInMessage()}
          color="#FFFFFF"
          overlayStyle={{ minWidth: "29.8rem" }}
          placement="right"
        />
      );
  };

  getTestId = (suffix: any) => {
    return this.props.testid ? `${this.props.testid}-${suffix}` : undefined;
  };

  render() {
    const { handleRadioChange, handleRadioClick, savedInRadioValue, disabled, testid } = this.props;
    return (
      <div
        className={styles.savedInContainer}
        data-highlight-id="ProcedureSavedInType1"
        data-testid={testid}
      >
        <div className={styles.savedInLabel}>
          <div className={styles.procedureSaveIn}>Procedure Saved In</div>
          {this.savedInMessageIcon()}
        </div>
        <div className={styles.radioBLock}>
          <Radio.Group
            onChange={(e) => handleRadioChange(e)}
            value={savedInRadioValue}
            defaultValue={savedInRadioValue}
            disabled={disabled}
            data-testid={this.getTestId("group")}
          >
            <Radio
              value={savedInRadioValues.systemOnly}
              onClick={(e) => handleRadioClick(e)}
              data-testid={this.getTestId("system-only")}
            >
              PMP System Only
            </Radio>
            <Radio
              value={savedInRadioValues.systemAndClientServer}
              onClick={(e) => handleRadioClick(e)}
              data-testid={this.getTestId("system-and-server")}
            >
              PMP System & Client Server
            </Radio>
            <Radio
              value={savedInRadioValues.serverOnly}
              onClick={(e) => handleRadioClick(e)}
              data-testid={this.getTestId("server-only")}
            >
              Client Server Only
            </Radio>
          </Radio.Group>
        </div>
      </div>
    );
  }
}
